import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["consent", "user", "getUserConsent", "updateUser"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import find from 'lodash/find';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { ActionType, ConsentType } from '../../enums/consent';
import { getUserConsent as getUserConsentAction, updateUser as updateUserAction } from '../../state/actions';
import { NewCardForm } from './NewCardForm';
import { jsx as _jsx } from "react/jsx-runtime";

var NewCardFormContainer = function NewCardFormContainer(_ref) {
  var consent = _ref.consent,
      user = _ref.user,
      getUserConsent = _ref.getUserConsent,
      updateUser = _ref.updateUser,
      props = _objectWithoutProperties(_ref, _excluded);

  var agreedToSubkitTermsConsent = find(consent, function (currentConsent) {
    return currentConsent.actionType === ActionType.GIVE && currentConsent.consentType === ConsentType.SUBKIT_TERMS_AND_PRIVACY;
  });
  useEffect(function () {
    if (user !== null && user !== void 0 && user.id) {
      getUserConsent(user.id);
    }
  }, [user]);

  if (!user) {
    return null;
  }

  return /*#__PURE__*/_jsx(NewCardForm, _objectSpread({
    userAgreedToSubkitTerms: !!agreedToSubkitTermsConsent,
    userNameExists: !!user.firstName && !!user.lastName,
    updateUser: updateUser,
    userId: user.id
  }, props));
};

var mapStateToProps = function mapStateToProps(state) {
  var _state$auth$users;

  return {
    user: (_state$auth$users = state.auth.users) === null || _state$auth$users === void 0 ? void 0 : _state$auth$users.current,
    consent: state.auth.consent
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getUserConsent: function getUserConsent(id) {
      return dispatch(getUserConsentAction(id));
    },
    updateUser: function updateUser(id, user) {
      return dispatch(updateUserAction(id, user, false));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewCardFormContainer);